import React from 'react'
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import { useCustomSearchParams } from '../../../../hooks/useCustomSearchParams';
import useDownloader from 'react-use-downloader';
import toast from 'react-hot-toast';

function DownloadUnitSurveyForm({ building_id, unit_number, unit_id, api ,ll55=false}) {
  const { download } = useDownloader();
  const [year, setYear] = useCustomSearchParams("year");
  

  const downloadMailer = () => {
    api({
      building_id,
      unit_id: unit_id,
      year,
      download_and_send: false,
    })
      .then((res) => {
        download(
          `${process.env.REACT_APP_BASE_URL}${ll55 ? "" : "/pdf/"}${
            ll55 ? res.data.pdf_file_path : res.data
          }`,
          "survey-form-" + unit_number + ".pdf"
        );
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.message);
      });
  };
  return (
    <div>
      {year == new Date().getFullYear() && (
        <SimCardDownloadIcon
          fontSize="medium"
          className="cursor-pointer"
          color="action"
          onClick={downloadMailer}
        />
      )}
    </div>
  );
}

export default DownloadUnitSurveyForm